module.exports = __webpack_public_path__ + "static/meditation-2bef0611712a26429e303c41557ca5fd.mp4";